import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UpdateService } from '../../../../services/update.service';
import { WeatherStationsService } from '../../../../models/weather-station-stats/service';
import { IMarker } from '../../interfaces';
import { DIALOG_HIDE_CLASS } from '../../../shared/constants';
import { RanchWeatherStationFormComponent } from '../../shared/ranch-weather-station-form/main';

@Component({
	moduleId: module.id,
	selector: 'ranch-weather-station-modal',
	templateUrl: 'main.html',
	styleUrls: ['main.scss']
})

export class RanchWeatherStationModalComponent implements OnDestroy {
	public isSaving = false;

	@ViewChild(RanchWeatherStationFormComponent, { static: false })
	public weatherStationForm: RanchWeatherStationFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		private _dialogRef: MatDialogRef<RanchWeatherStationModalComponent>,
		private _updateService: UpdateService,
		private _weatherStationService: WeatherStationsService
	) {
		this._subscriptions$ = new Subject();

		this._dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe(() => {
				this.close();
			});
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public addSelectedStations(stations: IMarker[]): void {
		if (!stations || stations.length === 0) {
			this._dialogRef.close();
			return;
		}

		if (this.isSaving) {
			return;
		}

		this.isSaving = true;

		this._weatherStationService.addStationsToRanch(stations)
			.then(() => {
				this.isSaving = false;
				this._updateService.setRanchSettingsUpdated('weatherStations');
				this._dialogRef.close();
			});
	}

	public close(): void {
		if (!this.weatherStationForm) {
			this._dialogRef.close();
			return;
		}

		this.weatherStationForm.cancel();
	}

	public hide(): void {
		this._dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this._dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}
}
